import React, { useEffect, useState } from "react";
import { BlackTickIcon, CancelIcon, EmojiIcon, FaceBookIcon, LiveChatAddColorIcon, LivechatAttachmentIcon, LiveChatByFalkonSystemsIcon, LiveChatCameraIcon, LivechatEmojiIcon, LiveChatMenuIcon, LiveChatMessageComposerIcon, LiveChatMinimizeIcon, LivechatSendMessageIcon, MessageDeliveredIcon, ProfileCameraIcon, SuccessBlueIcon, UpgradePlanIcon, WhatsAppIcon, WhiteTickIcon, } from "../../icon";
import ButtonComponent from "../shared/button/button.component";
import Avatar from "../shared/avatar.component";
import Config from "../../config";
import setToast from "../../helpers/toaster.helper";
import { Tags, ToasterTexts } from "../shared/constants";
import { ToasterType } from "../shared/toaster/toaster.model";
import Emojis from "../conversations/emojis";
import ImageComponent from "../shared/media/image.component";
import { ChannelAccountModel, ChannelType, ChannelWelcomeStatusModel, VisitorLoginType, WidgetTitle } from "../../models/channels/channels.model";
import { Autocomplete, Checkbox, Dialog, DialogContent, DialogTitle, FormHelperText, Popover, TextField, Tooltip } from "@mui/material";
import Mentions from "../shared/mentions";
import CustomSwitch from "../shared/switch.component";
import ReactGPicker from 'react-gcolor-picker';
import { useSelector } from "react-redux";
import * as selector from '../../selectors/selectors';
import { LiveChatService } from "../../services/channels/LiveChatService";
import { LoadChannels } from "../../actions";
import { useDispatch } from "react-redux";
import { ChannelUserModel, mapToChannelUser } from "../../models/users.model";
import { AppRoutes } from "../routes/route.path";
import { useNavigate } from "react-router";
import { stringlengthValidator } from "../shared/form-validation";


interface IProps {
    Channel?: ChannelAccountModel;
    Hide?: boolean;
    HandleNext?: (x) => void;
    StepData: any;
    PremiumFeatures: boolean;
}

const ChatWidgetTitle = (props: IProps) => {
    const dispatch = useDispatch()
    const navigate = useNavigate();

    const IsWordPress: boolean = useSelector(selector.IsWordpress)
    const IsShopify: boolean = useSelector(selector.IsShopify)

    const widgetTitleOptions = [{ Name: "Name & Logo", Value: 1 }, { Name: "Only Name", Value: 2 }]

    const emojiRef = React.createRef<HTMLButtonElement>();
    const ColorPickerRef = React.createRef<SVGSVGElement>();
    const [title, setTitle] = useState<string>(props.Channel?.Name || "");
    const [logo, setLogo] = useState<any>(props.Channel?.ChannelIcon || "");
    const [titleError, setTitleError] = useState<string>("");
    const [headerTextColor, setHeaderTextColor] = useState<string>("#fffff")
    const [mediaUrl, setMediaUrl] = useState<string>("");
    const [mediatype, setMediatype] = useState<string>("");
    const [mediaName, setMediaName] = useState<string>("");
    const [welcomeMessageStatus, setWelcomeMessageStatus] = useState<boolean>(false);
    const [IsLoading, setIsLoading] = useState<boolean>(false);
    const [body, setBody] = useState<string>("")
    const [emoji, setEmoji] = useState<string>("")
    const [anchorEmjoi, setAnchorEmoji] = useState<Element | null>(null)
    const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false)
    const [color, setColor] = useState(props.Channel?.PremiumFeatures?.WidgetColor || "linear-gradient(65deg, rgb(20, 80, 255) 50%, rgb(10, 40, 128) 90%)");
    const [anchorColorPicker, setAnchorColorPicker] = useState<Element | null>(null)
    const [widgetHeaderType, setWidgetHeaderType] = useState<number>(props.Channel?.PremiumFeatures?.WidgetTitleType || 1)
    const [falkonBranding, setFalkonBranding] = useState<boolean>(props.Channel?.PremiumFeatures?.IsAllowFalkonBranding || true)
    const [questionnarie, setQuestionnarie] = useState<boolean>(props.Channel?.PremiumFeatures.IsShowRating || false)

    const user = mapToChannelUser(JSON.parse(localStorage.getItem("current-user"))) as ChannelUserModel;

    useEffect(() => {
        if (props.Channel || props.StepData) {
            let MediaName = !!props.Channel && (props.Channel?.ChannelIcon as unknown as string).substring(props.Channel?.ChannelIcon.lastIndexOf("/") + 1)
            setBody(props.Channel?.ChannelWelcomeMessage || props.StepData?.WelcomeMessage)
            setMediaName(props.StepData?.MediaName || MediaName)
            setTitle(props.Channel?.Name || props.StepData?.WidgetTitle)
            setMediaUrl(props.Channel?.ChannelIcon || props.StepData?.MediaUrl)
            setLogo(props.Channel?.ChannelIcon || props.StepData?.WidgetLogo)
            setWelcomeMessageStatus(props.Channel?.ChannelWelcomeMessageStatus === ChannelWelcomeStatusModel.ACTIVE ? true : false || props.StepData?.WelcomeMessageStatus === ChannelWelcomeStatusModel.ACTIVE ? true : false)
            setColor((!props.PremiumFeatures && "linear-gradient(65deg, rgb(20, 80, 255) 50%, rgb(10, 40, 128) 90%)") || props.Channel?.PremiumFeatures?.WidgetColor || props.StepData?.WidgetColor)
            setWidgetHeaderType((!props.PremiumFeatures && WidgetTitle.NAME_AND_LOGO) || props.Channel?.PremiumFeatures?.WidgetTitleType || props.StepData?.WidgetHeaderType)
            setFalkonBranding((!props.PremiumFeatures && true) || props.Channel?.PremiumFeatures?.IsAllowFalkonBranding || props.StepData?.IsAllowFalkonBranding)
            setQuestionnarie((!props.PremiumFeatures && false) || props.Channel?.PremiumFeatures.IsShowRating || props.StepData?.IsShowRating)
            setHeaderTextColor((!props.PremiumFeatures && "#0F0F0F") || props.Channel?.PremiumFeatures?.HeaderTextColor || props?.StepData?.HeaderTextColor)
        }
    }, [props.Channel])

    const welcomeMessageStatusChange = () => {
        setWelcomeMessageStatus(!welcomeMessageStatus);
    };

    const handleValue = (e) => {
        setTitle(e.target.value)
        setTitleError(stringlengthValidator("Title", e.target.value, 20))
    }

    const handleHeaderTextColorChange = (color) => {
        setHeaderTextColor(color)
    }

    const exportTitle = () => {
        if (!!titleError) {
            return
        }
        if (!title) {
            setTitleError("Title canot be blank")
        }
        else if (props.PremiumFeatures) {
            props.HandleNext({ PremiumFeatures: props.PremiumFeatures, WidgetTitleType: widgetHeaderType, WidgetTitle: title, WelcomeMessage: body, WidgetLogo: logo, WelcomeMessageStatus: welcomeMessageStatus === true ? ChannelWelcomeStatusModel.ACTIVE : ChannelWelcomeStatusModel.INACTIVE, WidgetColor: color, MediaUrl: mediaUrl, MediaName: mediaName, IsShowRating: questionnarie, IsAllowFalkonBranding: falkonBranding, HeaderTextColor: headerTextColor })
        }
        else {
            let logodata = { file_name: mediaUrl?.includes("s3.us-central-1.wasabisys.com") ? "" : mediaName, value: mediaUrl?.includes("s3.us-central-1.wasabisys.com") ? mediaUrl : mediaUrl?.split(',')[1] } as any
            let formData = {
                "name": title,
                "welcome_message": body,
                "welcome_message_status": welcomeMessageStatus === true ? ChannelWelcomeStatusModel.ACTIVE : ChannelWelcomeStatusModel.INACTIVE,
                "widget_type": WidgetTitle.NAME_AND_LOGO,
                "widget_color": color,
                "text_color": "#0F0F0F",
                "visitor_login_Type": VisitorLoginType.ALLOW_LOGIN_AND_ANONYMOUS_LOGIN,
                "anonymous_user_settings": "1_Hour",
                "login_fields": [],
                "channels": [],
                "isAllowFalkonBranding": true,
                "isIncludeQuestionnaire": false,
                "channel_logo": logodata
            }
            setIsLoading(true)
            if (!!props.Channel) {
                LiveChatService.EditLiveChatChannel(user.OrganizationID, props.Channel.ID, formData).then((res) => {
                    setToast(`${title} has been updated Sucessfully!`, ToasterType.SUCCESS, "default")
                    setIsLoading(false)
                    LoadChannels(dispatch, user.OrganizationID)
                    navigate(AppRoutes.CHANNELS)
                }).catch((err) => {
                    if (err.response.data === "unsupported file type") {
                        setToast("unsupported file type", ToasterType.DANGER, "default")
                        setIsLoading(false)
                    }
                })
            }
            else {
                LiveChatService.CreateLiveChatChannel(user.OrganizationID, ChannelType.LIVE_CHAT, formData).then((res) => {
                    LoadChannels(dispatch, user.OrganizationID)
                    props.HandleNext({
                        ChannelID: res.data.created_channel_accounts[0],
                        WidgetTitle: title
                    })
                    setIsLoading(false)
                }).catch(err => { setIsLoading(false) })
            }
        }
    }

    const toBase64 = (file: any) =>
        new Promise<any>((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

    const OnLogoInsert = async (e: any) => {
        let file = e.target.files[0];
        if (file != null && file.size < Config.CHANNEL_FILE_SIZE) {
            setLogo(file);
            setMediaUrl(await toBase64(file));
            setMediatype(file.type.split("/")[0]);
            setMediaName(file.name);
        } else {
            e.target.value = "";
            setToast(
                ToasterTexts.FILE_SIZE_EXCEED_LIMIT.replace("<size>", (Config.CHANNEL_FILE_SIZE / 1000000).toFixed(0)),
                ToasterType.DANGER
            );
        }
    };

    const handleEmojiSelect = (e: any) => {
        setEmoji(e.native)
        setTimeout(() => {
            setEmoji("")
        }, 100)
        setAnchorEmoji(null)
    };

    const getFileName = (MediaName): string => {
        var Name = MediaName.split('.')[0]
        return Name.slice(0, 24) + (MediaName.length > 24 ? "..." : "");
    }

    const getFileExtension = (MediaName): string => {
        let parts = mediaName.split('.');
        return parts[parts.length - 1];
    }

    const closeMedia = () => {
        setLogo("");
        setMediaUrl("");
        setMediatype("");
        setMediaName("");
    };

    const onChange = (event: any) => {
        setBody(event.target.value.replace(/[\u200B-\u200D\uFEFF]/g, ''))
    }

    const closeConfirm = () => {
        setOpenConfirmDialog(false)
    }

    const handlefalkonBranding = () => {
        setFalkonBranding(!falkonBranding)
    }

    const handleQuestionnarie = () => {
        setQuestionnarie(!questionnarie)
    }

    return (

        <div className="add-phone-number-paper-border paper-background h-p-100 m-auto br-2 d-flex flex-direction justify-center align-center">
            <div className="h-p-100 w-p-100 d-flex">
                <div className="w-p-56 d-flex flex-direction ">
                    {!props.Hide &&
                        <div className="h-p-8 w-p-100 h2-semibold d-flex align-end mx-2">
                            Connect with your website visitors
                        </div>
                    }
                    {props.PremiumFeatures && <div className={`${!props.Hide ? "h-p-15" : "h-p-20"}`}>
                        <div className="h-p-40 w-p-94 mx-2 d-flex h5-medium align-end">
                            Widget Header Type
                        </div>
                        <div className="h-p-60 w-p-100">
                            <Autocomplete
                                className="ml-2 w-p-94"
                                disableClearable
                                size="small"
                                classes={{ input: 'h4-regular', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                options={widgetTitleOptions}
                                getOptionLabel={(option: any) => option.Name}
                                onChange={(e, value) => { setWidgetHeaderType(value.Value) }}
                                value={widgetTitleOptions.find(x => x.Value === widgetHeaderType)}
                                renderInput={(params) =>
                                    <TextField {...params} size="small" variant="outlined" placeholder="Select Type" name="Select Type" onKeyDown={(e) => { e.preventDefault(); }} />}
                                renderOption={(defaultprops, option: any) => (
                                    <li {...defaultprops} >
                                        {
                                            <div className={" c-pointer h4-regular color-menu-list-font-color d-flex justify-between w-p-92"}>
                                                {option?.Name}
                                            </div>
                                        }
                                    </li>
                                )}
                            />
                        </div>
                    </div>
                    }
                    <div className={`${props.PremiumFeatures ? "h-p-15" : "h-p-20"}`}>
                        <div className="h-p-40 w-p-94 mx-2 d-flex h5-medium align-end">
                            Enter Chat Widget Title
                        </div>
                        <div className="h-p-60 w-p-100">
                            <TextField
                                className="ml-2 w-p-94"
                                placeholder="Name"
                                variant="outlined"
                                size="small"
                                fullWidth
                                value={title}
                                onChange={(e) => handleValue(e)}
                                InputProps={{ classes: { input: 'h4-regular' } }}
                                autoComplete='no'
                            />
                            <FormHelperText className="h6-regular color-primary-danger t-align-right mr-3">
                                {titleError}
                            </FormHelperText>

                        </div>
                    </div>
                    <div className={`${!props.Hide ? "h-p-15" : "h-p-26"}`}>
                        <div className="h-p-100 w-p-94 d-flex mx-2">
                            {props.PremiumFeatures && <div className="w-p-42 h-p-100 mr-2">
                                <div className="h-p-40 w-p-100 d-flex h5-semibold align-end">
                                    Widget Color
                                </div>
                                <div className="h-p-60 w-p-100 h4-regular align-end mt-1">
                                    <div className="h-p-80 w-p-100 d-flex bg-color-select-widget-color br-5 justify-around">
                                        <div className="w-4 h-4 br-p-50 my-auto c-pointer" style={{ background: "linear-gradient(226deg, rgb(20, 80, 255) 0%, rgb(0, 50, 197) 100%)" }} onClick={() => setColor("linear-gradient(226deg, rgb(20, 80, 255) 0%, rgb(0, 50, 197) 100%)")}>
                                        </div>
                                        <div className="w-4 h-4 br-p-50 my-auto c-pointer" style={{ background: "linear-gradient(226deg, rgb(0, 216, 86) 0%, rgb(0, 156, 62) 100%)" }} onClick={() => setColor("linear-gradient(226deg, rgb(0, 216, 86) 0%, rgb(0, 156, 62) 100%)")}>
                                        </div>
                                        <div className="w-4 h-4 br-p-50 my-auto c-pointer" style={{ background: "linear-gradient(226deg, rgb(216, 106, 0) 0%, rgb(206, 4, 4) 100%)" }} onClick={() => setColor("linear-gradient(226deg, rgb(216, 106, 0) 0%, rgb(206, 4, 4) 100%)")}>
                                        </div>
                                        {!props.Hide && <div className="w-4 h-4 br-p-50 my-auto c-pointer" style={{ background: "linear-gradient(90deg, rgb(216, 189, 0) 0%, rgb(233, 233, 49) 100%)" }} onClick={() => setColor("linear-gradient(90deg, rgb(216, 189, 0) 0%, rgb(233, 233, 49) 100%)")}>
                                        </div>}
                                        <LiveChatAddColorIcon className="w-4 h-4 my-auto c-pointer" ref={ColorPickerRef}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                if (anchorColorPicker) {
                                                    setAnchorColorPicker(null)
                                                } else {
                                                    setAnchorColorPicker(ColorPickerRef.current)
                                                }
                                            }} />
                                    </div>
                                </div>
                            </div>
                            }
                            {props.PremiumFeatures && <div className="w-p-20 h-p-100 min-w-12 max-w-12 mr-2">
                                <div className="h-p-40 d-flex h5-semibold align-end">
                                    Header Text
                                </div>
                                <div className="h-p-60 w-p-100 h4-regular align-end mt-1">
                                    <div className="h-p-80 w-p-100 d-flex bg-color-select-widget-color br-5 justify-around">
                                        <div className="w-4 h-4 br-p-50 my-auto c-pointer bg-color-primary-accent d-flex justify-center align-center" onClick={() => handleHeaderTextColorChange("#ODODOD")} style={{ border: "1px solid black" }}>
                                            {headerTextColor === "#ODODOD" && <WhiteTickIcon className="w-2 h-2" />}
                                        </div>
                                        <div className="w-4 h-4 br-p-50 my-auto c-pointer bg-color-secondary d-flex justify-center align-center" onClick={() => handleHeaderTextColorChange("#fffff")} style={{ border: "1px solid #d6d6d6" }}>
                                            {headerTextColor === "#fffff" && <BlackTickIcon className="w-2 h-2" />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            }
                            {widgetHeaderType === WidgetTitle.NAME_AND_LOGO && <div className={`w-p-40 h-p-100 ${props.Hide ? "min-w-20 max-w-20" : "min-w-20 max-w-20"}`}>
                                <div className="h-p-40 d-flex h5-semibold align-end">
                                    Upload Logo
                                </div>
                                <div className="h-p-60 h4-regular align-end mt-1">
                                    {!logo ?
                                        <div className={`h-p-80 ${props.Hide ? "min-w-20 max-w-20" : "min-w-20 max-w-20"} d-flex bg-color-secondary box-shadow-channel  br-5 c-pointer`}>
                                            <input
                                                color="primary"
                                                accept="image/*"
                                                type="file"
                                                onChange={OnLogoInsert}
                                                style={{ display: "none" }}
                                                id={"icon-button-file"}
                                                className="w-p-100 c-pointer"
                                            />
                                            <label htmlFor={"icon-button-file"} className="w-p-100 d-flex c-pointer">
                                                <div className="w-p-20 h-p-100 d-flex justify-center align-center ml-2">
                                                    <div className="w-4 h-4 br-p-50 bg-color-secondary d-flex justify-center align-center">
                                                        <LiveChatCameraIcon className="" />
                                                    </div>
                                                </div>
                                                <div className="w-p-80 d-flex align-center h4-medium">
                                                    Select File
                                                </div>
                                            </label>
                                        </div>
                                        :
                                        <div className={`h-p-80 ${props.Hide ? "min-w-20 max-w-20" : "min-w-20"} d-flex bg-color-select-widget-color br-5`}>
                                            <div className="d-flex justify-center align-center mx-1">
                                                <Avatar ImgSrc={!logo ? "" : mediaUrl && mediaUrl} Size={32} Name={title} className=" d-flex justify-center align-center" />
                                            </div>
                                            <div className="d-flex align-center h5-medium flex-1 w-space">
                                                {getFileName(mediaName) + "." + getFileExtension(mediaName)}
                                            </div>
                                            <div className="d-flex justify-center align-center mx-1">
                                                <CancelIcon
                                                    className={"c-pointer"}
                                                    onClick={closeMedia}
                                                />
                                            </div>
                                        </div>

                                    }
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                    <div className={`${!props.Hide ? "h-p-28 mt-1" : "h-p-40"}`}>
                        <div className="h-p-30 w-p-94 ml-2 d-flex align-center h5-semibold">
                            <div className="mr-2">
                                Greeting Message
                            </div>
                            {/* <AntSwitch inputProps={{ 'aria-label': 'ant design' }} checked={welcomeMessageStatus} onChange={welcomeMessageStatusChange} /> */}
                            <span className={``}>
                                <CustomSwitch
                                    checked={welcomeMessageStatus}
                                    onChange={(checked: boolean) => welcomeMessageStatusChange()}
                                />
                            </span>
                        </div>
                        <div className=" h-p-80 w-p-100 pr-1 h5-regular o-hidden ml-1">
                            <div className="w-p-94 h-p-48 br-2 b-live-chat-message-composer d-flex bg-color-secondary mx-1 o-hidden align-center">
                                <div className="w-p-96 h-p-100 ml-1 o-hidden d-flex">
                                    <div className="w-p-94 o-y-scroll h-p-100 h4-regular mt-1">
                                        <Mentions
                                            body={body}
                                            placeholder={"Write a message..."}
                                            emoji={emoji}
                                            onKeyDown={(e) => { }}
                                            onChange={onChange}
                                            maxLength={960}
                                            tags={[]}
                                            id={""}
                                            openTags={false}
                                            tagTarget={undefined}
                                            closeTags={() => { }}
                                        />
                                    </div>
                                    <button className="w-p-6 h-p-100 d-flex justify-center align-center c-pointer"
                                        ref={emojiRef}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            if (anchorEmjoi) {
                                                setAnchorEmoji(null)

                                            } else {
                                                setAnchorEmoji(emojiRef.current)
                                            }
                                        }}>
                                        <EmojiIcon />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {props.PremiumFeatures && <div className="d-flex justify-between w-p-94 mx-auto">
                        <div className={" d-flex h5-semibold"}>
                            <Checkbox
                                name="checkbox"
                                onChange={handlefalkonBranding}
                                classes={{ checked: "selected-checkbox" }}
                                checked={falkonBranding}
                                className="m-0 p-0"
                                size="small"
                            />
                            <span className={`my-auto color-primary-accent ml-1`}>Falkon Branding</span>
                        </div>
                        <div className={" d-flex h5-semibold"}>
                            <Checkbox
                                name="checkbox"
                                onChange={handleQuestionnarie}
                                classes={{ checked: "selected-checkbox" }}
                                checked={questionnarie}
                                className="m-0 p-0"
                                size="small"
                            />
                            <span className={`my-auto color-primary-accent ml-1`}>Include Questionnarie</span>
                        </div>
                    </div>
                    }
                    <div className={`h-p-10 d-flex  mx-2 align-center justify-flex-end ${props.PremiumFeatures ? " justify-flex-end" : "justify-between"} `}>
                        {!props.PremiumFeatures && <div className="h-p-70 bg-color-upgrade-plan br-50 d-flex align-center px-2 upgrade-plan-border c-pointer" onClick={() => setOpenConfirmDialog(true)}>
                            <div><UpgradePlanIcon /></div>
                            <div className="h6-medium color-primary-accent">
                                Pro Trial :
                            </div>&nbsp;
                            <div className="h6-regular color-primary-accent">Upgrade to get premium features</div>
                        </div>}
                        <ButtonComponent ButtonLabel={!props.Hide ? "Next" : "Save"} Loading={IsLoading} OnClick={exportTitle} Variant={"primary-btn"} ClassName="h-p-70"></ButtonComponent>
                    </div>
                </div>
                <div className="w-p-44 h-p-100 mr-2">
                    {!props.Hide &&
                        <div className="h-p-8 w-p-90 mx-auto d-flex align-end h5-semibold">
                            Live Chat Preview
                        </div>
                    }
                    <div className="h-p-90 w-p-90 m-auto d-flex align-center justify-center">
                        <div className={`${props.Hide ? "" : "add-phone-number-paper-border"} h-p-96 w-p-100 br-2 d-flex justify-center align-center`}>
                            <div className=" o-hidden br-2 d-flex flex-direction" style={{ boxShadow: "0px 12px 35px #4746464D", width: "300px", height: (IsWordPress || IsShopify) ? "350px" : "435px", }}>

                                <div className={`min-h-7 w-p-100 d-flex flex-direction ${headerTextColor === "#ODODOD" ? "color-primary-accent" : "color-secondary"}`} style={{ background: color }}>
                                    <div className="d-flex w-p-100 min-h-7 align-center">
                                        {widgetHeaderType === WidgetTitle.NAME_AND_LOGO && <div className={`w-p-20 d-flex justify-center align-center`}>
                                            <Avatar ImgSrc={!logo ? "" : mediaUrl && mediaUrl} Size={38} Name={title} className=" d-flex justify-center align-center" />
                                        </div >
                                        }
                                        <div className={` ${widgetHeaderType === WidgetTitle.NAME_AND_LOGO ? "w-p-60" : "w-p-80 pl-2"} d-flex justify-center flex-direction`}>
                                            <div className={`w-p-100  d-flex align-center r-h2-regular `} >{title ? `${title.length > 18 ? title.slice(0, 15) + "..." : title}` : ""}</div>
                                            <div className={`br-2 d-flex align-center r-footnote`}>
                                                <MessageDeliveredIcon className={"mr-1"} />
                                                Online
                                            </div>
                                        </div >
                                        <div className={`w-p-10 d-flex justify-center align-center`}>
                                            <LiveChatMinimizeIcon width={20} height={20} />
                                        </div>
                                        <div className={`w-p-10 d-flex justify-center align-center ml-auto`}>
                                            <LiveChatMenuIcon className={"mr-1 "} />
                                        </div>
                                    </div>
                                    {/* {props.PremiumFeatures &&
                                        <div className="d-flex align-center min-h-4">
                                            <div className="ml-2 r-h6-medium">Connect with</div>
                                            <FaceBookIcon width={20} height={20} className="mx-1" />
                                            <WhatsAppIcon />
                                        </div>
                                    } */}
                                    <div className="w-p-100 h-2">
                                        <div className="w-p-100 h-p-100 bg-color-live-chat-widget-hist-background" style={{ borderRadius: "50px 50px 0 0" }}></div>
                                    </div>
                                </div >
                                <div className={`min-h-20 bg-color-live-chat-widget-hist-background o-hidden flex-1 p-relative`}>
                                    {(!!body && welcomeMessageStatus) &&
                                        <div className=" d-flex ml-2 align-end w-p-100 ">
                                            {widgetHeaderType === WidgetTitle.NAME_AND_LOGO &&
                                                <Avatar ImgSrc={!logo ? "" : mediaUrl && mediaUrl} Name={title} className=" d-flex justify-center align-center mt-auto" Size={30} />}
                                            <div className="live-chat-inboundmsg bg-color-secondary h5-medium t-align-left w-break p-1 mt-2 ml-1 w-p-60 min-h-2 o-y-scroll ">
                                                {body}
                                            </div>
                                        </div>
                                    }
                                </div>

                                <div className={` w-p-100 d-flex align-center justify-center bg-color-secondary live-chat-composer h-p-12`}>

                                    <div className={`b-live-chat-message-composer  w-5 h-5 d-flex justify-center align-center br-p-50`}>
                                        <LivechatAttachmentIcon className={`w-2 h-2`} />
                                    </div>
                                    <div className={`w-p-60 max-h-10 o-hidden ${"br-5"} b-live-chat-message-composer d-flex pl-2 `} style={{ marginRight: "6px", marginLeft: "6px" }}>
                                        <div className="w-p-100 max-h-10 o-y-scroll bg-color-secondary ">
                                            <div className={`w-p-100 h-p-100 min-h-5 my-auto d-flex align-center h6-regular`} >
                                                Send us a message!
                                            </div>
                                        </div>
                                        <div className="d-flex align-center justify-center w-p-15 h-5 mt-auto mr-1">
                                            <LivechatEmojiIcon />
                                        </div>

                                    </div>
                                    <div className={`b-live-chat-message-composer d-flex justify-center align-center br-p-50 w-5 h-5`} style={{ background: color }}>
                                        <LivechatSendMessageIcon />
                                    </div>
                                </div>
                                {falkonBranding &&
                                    <div className="h-p-6 d-flex justify-center align-center bg-color-secondary" >
                                        <LiveChatByFalkonSystemsIcon className="w-2 h-2" />
                                        <span className="d-flex align-center justify-center h-p-100 live-chat-footer color-live-chat-anonymous">&nbsp;Powered by&nbsp;&nbsp;<a href="https://www.falkonsystems.com/" target="_blank" style={{ color: "#3663ff", textDecoration: "none" }}>Falkon Systems</a>
                                            &nbsp;&&nbsp;<a href="https://www.falkonsms.com/" target="_blank" style={{ color: "#3663ff", textDecoration: "none" }}>Falkon SMS</a>
                                        </span>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                Boolean(anchorEmjoi) &&
                <Popover
                    open={Boolean(anchorEmjoi)}
                    anchorEl={anchorEmjoi}
                    onClose={() => setAnchorEmoji(null)}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                >
                    <Emojis handleEmojiSelect={handleEmojiSelect} />
                </Popover>
            }

            {
                openConfirmDialog && (
                    <Dialog
                        fullWidth
                        onClose={() => closeConfirm()}
                        aria-labelledby="responsive-dialog-title"
                        open={openConfirmDialog}
                        classes={{ paper: "br-2 w-p-45 min-w-50 dialogue-shadow bg-color-secondary" }}
                        BackdropProps={{ style: { backgroundColor: "transparent" } }}
                    >
                        <DialogTitle id="alert-dialog-title" className="dialog-header">
                            <div className='d-flex'>
                                <Tooltip title='Close' placement='bottom'>
                                    <CancelIcon className={"c-pointer ml-auto"} onClick={() => closeConfirm()} />
                                </Tooltip>
                            </div>
                        </DialogTitle>
                        <DialogContent className='py-1 px-3'>
                            <div className="d-flex align-center h1-medium color-primary-accent w-p-50 t-align-center mx-auto">
                                Premium features for your Live chat widget
                            </div>
                            <div className={"bb-primary-background-pink-4 w-p-94 mx-auto py-1"}></div>

                            <div className="d-flex align-center pt-2 pb-1 ml-3">
                                <SuccessBlueIcon />
                                <div className="ml-2 color-upgrade-plan-dialog-content h4-semibold">
                                    Custom Widget fields & Color section
                                </div>
                            </div>
                            <div className="color-upgrade-plan-dialog-content live-chat-subheader ml-8">
                                Customize titles and widget names suited to your company preferences.
                            </div>

                            <div className="d-flex align-center mt-3 pb-1 ml-3">
                                <SuccessBlueIcon />
                                <div className="ml-2 color-upgrade-plan-dialog-content h4-semibold">
                                    Visitor field customization
                                </div>
                            </div>
                            <div className="color-upgrade-plan-dialog-content live-chat-subheader ml-8">
                                Customize fields as required.
                            </div>

                            <div className="d-flex align-center mt-3 pb-1 ml-3">
                                <SuccessBlueIcon />
                                <div className="ml-2 color-upgrade-plan-dialog-content h4-semibold">
                                    Login form Customization
                                </div>
                            </div>
                            <div className="color-upgrade-plan-dialog-content live-chat-subheader ml-8">
                                Customize forms in login screen for customers.
                            </div>

                            <div className="d-flex align-center mt-3 pb-1 ml-3">
                                <SuccessBlueIcon />
                                <div className="ml-2 color-upgrade-plan-dialog-content h4-semibold">
                                    Include multiple channels
                                </div>
                            </div>
                            <div className="color-upgrade-plan-dialog-content live-chat-subheader ml-8">
                                From Facebook, Instagram and SMS.
                            </div>

                            <div className="d-flex align-center justify-center mt-1">
                                <ButtonComponent ButtonLabel={"Upgrade"} Variant={"primary-btn"} OnClick={() => { navigate(AppRoutes.CHANNELS_PLANS) }} />
                            </div>
                        </DialogContent>
                    </Dialog>
                )
            }
            {
                Boolean(anchorColorPicker) &&
                <Popover
                    open={Boolean(anchorColorPicker)}
                    anchorEl={anchorColorPicker}
                    onClose={() => { setAnchorColorPicker(null) }}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                >
                    <ReactGPicker value={color} onChange={(value) => { setColor(value) }} showAlpha={false} defaultActiveTab={"solid"} gradient />
                </Popover>
            }
        </div >
    )
}

export default ChatWidgetTitle;